/** Canonical labels and values rendered by screener filter controls. */

import type {
  AmendmentState,
  InsiderRole,
  MarketCapBucket,
  MissingFieldFlag,
  PlanStatus,
  SecurityStatus,
  SignalBucket,
  SignalConfidence,
  TradeType,
  ValueQuality
} from "../../lib/types";
import type { FilterOption } from "./filter-fields";

export const RELATIONSHIP_OPTIONS = [
  { label: "CEO", value: "CEO" },
  { label: "CFO", value: "CFO" },
  { label: "Director", value: "Director" },
  { label: "Officer", value: "Officer" },
  { label: "10% Owner", value: "10% Owner" },
  { label: "Other", value: "Other" }
] satisfies FilterOption<InsiderRole>[];

export const FILTER_CONTROL_CONFIG = {
  signals: [
    { label: "Informative buys", value: "informative_buy" },
    { label: "Informative sells", value: "informative_sell" },
    { label: "Routine buys", value: "uninformative_buy" },
    { label: "Routine sells", value: "uninformative_sell" },
    { label: "Needs review", value: "needs_review" }
  ] satisfies FilterOption<SignalBucket>[],
  relationships: ["CEO", "CFO", "Director", "Officer", "10% Owner", "Other"] satisfies InsiderRole[],
  plans: [
    { label: "Planned", value: "planned" },
    { label: "Not planned", value: "not_planned" },
    { label: "Plan unknown", value: "unknown" }
  ] satisfies FilterOption<PlanStatus>[],
  activities: [
    { label: "Buys", value: "buy" },
    { label: "Sells", value: "sell" },
    { label: "Options", value: "option" },
    { label: "Awards", value: "award" }
  ] satisfies FilterOption<TradeType>[],
  securityStatuses: [
    { label: "Common equity", value: "common_equity" },
    { label: "Non-common", value: "non_common" },
    { label: "Derivative", value: "derivative" },
    { label: "Unknown security", value: "unknown" }
  ] satisfies FilterOption<SecurityStatus>[],
  confidences: [
    { label: "High", value: "high" },
    { label: "Medium", value: "medium" },
    { label: "Low", value: "low" }
  ] satisfies FilterOption<SignalConfidence>[],
  amendments: [
    { label: "Original", value: "original" },
    { label: "Amendment", value: "amendment" }
  ] satisfies FilterOption<AmendmentState>[],
  valueQualities: [
    { label: "Reported", value: "reported" },
    { label: "Derived", value: "derived" },
    { label: "Missing value", value: "missing" },
    { label: "Suspect value", value: "suspect" }
  ] satisfies FilterOption<ValueQuality>[],
  missingFields: [
    { label: "Trade date", value: "tradeDate" },
    { label: "Price", value: "price" },
    { label: "Value", value: "value" },
    { label: "Holdings before", value: "holdingsBefore" },
    { label: "Holdings after", value: "holdingsAfter" },
    { label: "Owner CIK", value: "ownerCik" },
    { label: "Owner identity", value: "ownerIdentityKey" },
    { label: "Filing lag", value: "filingLagDays" }
  ] satisfies FilterOption<MissingFieldFlag>[],
  marketCaps: [
    { label: "Micro cap", value: "micro" },
    { label: "Small cap", value: "small" },
    { label: "Mid cap", value: "mid" },
    { label: "Large cap", value: "large" },
    { label: "Mega cap", value: "mega" },
    { label: "Unknown market cap", value: "unknown" }
  ] satisfies FilterOption<MarketCapBucket>[]
} as const;
